import React, { Component } from "react";
import { getStaticText } from '../../../lables/lablesService';
import ImageInput from '../../../components/image-input-component/imageInput';
import HtmlInput from '../../../components/html-input-component/htmlInput';
import TransportationToOrderPosts from '../api/transportationToOrderPosts';


class PostForm extends Component {


    constructor(props){
        super(props);

        this.save_type_process = false;
        this.state = {
            'increment' : 0
        };
    }


    changeInfoImage ( image_name, image ) {
        this.props.info.image_name = image_name;
        this.props.info.image = image;
        this.setState({
            'increment' : this.state.increment + 1
        });
    }


    changeInfoValue ( prop_name, prop_value ) {
    	let value = null;
        switch (prop_name) {
            case 'content':
                    value = prop_value;
                break;

            case 'active':
                    value = prop_value.target.checked ? 1 : 0;
                break;

            default:
                    value = prop_value.target.value
                break;
        }
        this.props.info[prop_name] = value;
    }


    async savePost () {
    	if ( this.save_type_process )
            return false;

        this.save_type_process = true;
        const formData = new FormData();

        if ( this.props.info.id > 0 )
            formData.append( 'id', this.props.info.id );

        if ( typeof(this.props.info.image) === 'object' )
            formData.append( 'image', this.props.info.image );

        formData.append( 'title', this.props.info.title );
        formData.append( 'type_id', this.props.info.type_id );
        formData.append( 'content', this.props.info.content );
        formData.append( 'active', this.props.info.active );
        formData.append( 'position', this.props.info.position );

        let result = null;
        if ( this.props.info.id === 0 )
            result = await TransportationToOrderPosts.add( formData );
        else
            result = await TransportationToOrderPosts.update( formData );
    
        if ( !result ) {
            window.alert( getStaticText('save_error') );
        } else {
            window.alert( getStaticText('save_success') );
            if ( typeof(this.props.formCallback) === 'function' )
            	this.props.formCallback();
        }

        this.save_type_process = false;
    }


	render () {
        let types_for_select = [];
        types_for_select.push(<option value="0" key="ttop_empty_category">{getStaticText('ttop_form_type_id_empty_opt')}</option>);
        for ( let id in this.props.categories ) {
            types_for_select.push(<option key={"ttop_type_id_opt_" + id} value={id}>{this.props.categories[id]}</option>);
        }

		return (<>

                <ImageInput 
                    label={getStaticText('ttop_form_image_input_label')}
                    fileImage={this.props.info.image || null}
                    fileName={this.props.info.image_name || null}
                    handleFile={this.changeInfoImage.bind(this)}
                />

                <div className="form-group">
                    <label
                        htmlFor="vcNameInput"
                    >
                        {getStaticText('ttop_form_title_input_label')}
                    </label>
                    <input 
                        id="vcNameInput"
                        className="form-control"
                        defaultValue={this.props.info.title}
                        onChange={this.changeInfoValue.bind(this, 'title')}
                    />
                </div>

                <div className="form-group">
                    <label
                        htmlFor="vpTypeIdInput"
                    >
                        {getStaticText('ttop_form_type_id_input_label')}
                    </label>
                    <select 
                        id="vpTypeIdInput"
                        className="form-control"
                        defaultValue={this.props.info.type_id}
                        onChange={this.changeInfoValue.bind(this, 'type_id')}
                    >
                        {types_for_select}
                    </select>
                </div>

                <HtmlInput 
                    label={getStaticText('ttop_form_description_input_label')}
                    content={this.props.info.content}
                    inputName="content"
                    onChangeContent={this.changeInfoValue.bind(this)}
                />

                <div className="form-group">
                    <label
                        htmlFor="vcPositionInput"
                    >
                        {getStaticText('ttop_form_position_input_label')}
                    </label>
                    <input 
                        id="vcPositionInput"
                        className="form-control"
                        defaultValue={this.props.info.position}
                        onChange={this.changeInfoValue.bind(this, 'position')}
                    />
                </div>

                <div className="form-group">
                    <label>
                        <input 
                            type="checkbox"
                            defaultChecked={this.props.info.active}
                            onChange={this.changeInfoValue.bind(this, 'active')}
                        /> {getStaticText('ttop_form_active_input_label')}
                    </label>
                </div>

                <div className="form-group os-text-right">
                    <button
                        className="btn btn-success"
                        onClick={this.savePost.bind(this)}
                    >
                        {this.props.info.id ? getStaticText('ttop_form_update_button_label') : getStaticText('ttop_form_add_button_label')}
                    </button>
                </div>
			</>);
	}

}


export default PostForm;